import { getBuildingGroupOptions } from '../../../api'
import { getItemsFromIdwellApiResponse } from '../../../utils/api'
import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { toBuildingGroupSelectItems } from '../BuildingGroup.utils'

import BuildingsGroupIcon from '../../../icons/buildings-group.svg'

function BuildingGroupSelect({
  Control = InputSelectControl,
  getData = getBuildingGroupOptions,
  getDataItems = getItemsFromIdwellApiResponse,
  toPreparedItems = toBuildingGroupSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      EntityIcon={BuildingsGroupIcon}
      getData={getData}
      getDataItems={getDataItems}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default BuildingGroupSelect
